import { Loader2, Search } from "lucide-react";

export const SearchBox = ({ value, onChange, placeholder = "Rechercher…", testId = "list-search" }) => (
  <label className="flex items-center gap-3 border-b-2 border-white/30 focus-within:border-primary transition-colors max-w-md w-full">
    <Search className="w-5 h-5 text-zinc-400" />
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      data-testid={testId}
      className="flex-1 bg-transparent py-3 text-white text-lg outline-none placeholder:text-zinc-500"
    />
  </label>
);

export const LoadMore = ({ list, testId = "load-more-btn" }) =>
  list.hasMore ? (
    <div className="mt-16 flex justify-center">
      <button
        onClick={list.loadMore}
        disabled={list.isFetching}
        data-testid={testId}
        className="inline-flex items-center gap-3 border-2 border-white text-white font-display uppercase text-xl px-10 py-4 hover:bg-white hover:text-black transition-colors duration-200 disabled:opacity-50"
      >
        {list.isFetching && <Loader2 className="w-5 h-5 animate-spin" />} Charger plus
      </button>
    </div>
  ) : null;
